
import { Pagination, Stack, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { colorPorNumero, envVariables } from "../../../../helpers";
import { useMovimientosStore } from "../../../../store";
import { AlertScreen } from "../../components/AlertScreen";
import { LayoutTabla } from "../../../layout";

import dayjs from "dayjs";
const paginado = Number(envVariables.REACT_APP_PAGINADO);




export const TablaMovimientosStock = ({ data, chagePage=null, page=0 }) => {


    const { totalMovimientos } = useMovimientosStore();


    return (
        <>
        {(data.length > 0) 
        ?   <LayoutTabla
                paginado={
                     <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <Pagination count={Math.ceil(totalMovimientos / paginado)}  disabled={Math.ceil(totalMovimientos / paginado) === 1}
                            variant="outlined" page={page + 1} color="primary" 
                            onChange={ (_, newValor) => chagePage(newValor) } 
                        />
                    </Stack>
                }
            >
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ width:'15%' }}>FECHA</TableCell>
                        <TableCell sx={{ width:'20%' }}>PRODUCTO</TableCell>
                        <TableCell sx={{ width:'15%' }}>INICIAL</TableCell>
                        <TableCell sx={{ width:'10%' }}>CANTIDAD</TableCell>
                        <TableCell sx={{ width:'15%' }}>FINAL</TableCell>
                        <TableCell sx={{ width:'15%' }}>TIPO</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {data.map( (pro) => (
                    <TableRow key={ pro.id }>
                        <TableCell>{ dayjs(pro.createdAt).format('DD/MM/YYYY') }</TableCell>
                        <TableCell >{ pro.producto.nombre  }</TableCell>
                        <TableCell>{ pro.cantidadInicial }</TableCell>
                        <TableCell sx={{color: colorPorNumero(pro.cantidad)}}>{ pro.cantidad }</TableCell>
                        <TableCell>{ pro.cantidadFinal }</TableCell>
                        <TableCell>{ pro.tipo }</TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </LayoutTabla>

        :   <AlertScreen title="No hay movimientos por el momento..."/>
        }
        </>
    )
}
